import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { http } from "../lib/api";
import { CheckCircle2, ArrowLeft, Loader2 } from "lucide-react";
import { track } from "../lib/analytics";

export const ShopSuccess = () => {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("loading");
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!sid) { setStatus("missing"); return; }
    http.get(`/shop/order/${sid}`)
      .then((r) => {
        setOrder(r.data);
        setStatus("ok");
        if (r.data.payment_status === "paid") {
          track("purchase", { transaction_id: sid, value: (r.data.amount_total || 0) / 100, currency: "USD" });
        }
      })
      .catch(() => setStatus("error"));
  }, [sid]);

  return (
    <div data-testid="shop-success-page" className="mx-auto max-w-2xl px-6 py-24 text-center">
      {status === "loading" && (
        <div className="text-neutral-400 flex items-center justify-center gap-3">
          <Loader2 className="w-4 h-4 animate-spin" /> confirming your order...
        </div>
      )}
      {status === "ok" && (
        <>
          <CheckCircle2 className="w-16 h-16 text-[color:var(--accent-matrix)] mx-auto mb-6" />
          <div className="text-[10px] uppercase tracking-[0.3em] text-[color:var(--accent-matrix)] mb-3">// order confirmed</div>
          <h1 className="font-display font-bold text-4xl tracking-tight mb-4">thank you.</h1>
          <p className="text-neutral-400 mb-6">
            {order?.payment_status === "paid"
              ? `payment received — $${((order.amount_total || 0) / 100).toFixed(2)}. we'll email you when your order ships.`
              : "payment is processing. you'll hear from us shortly."}
          </p>
          <Link
            to="/shop"
            className="inline-flex items-center gap-2 text-[10px] uppercase tracking-widest border border-white/15 hover:border-[color:var(--accent-amber)] px-4 py-2 text-neutral-300 duration-150"
            style={{ transitionProperty: "border-color" }}
          >
            <ArrowLeft className="w-3 h-3" /> back to the drop
          </Link>
        </>
      )}
      {status === "error" && (
        <div className="text-neutral-400">couldn't verify order. contact ops if this persists.</div>
      )}
      {status === "missing" && (
        <div className="text-neutral-400">no session id found. <Link to="/shop" className="text-[color:var(--accent-amber)]">back to shop</Link></div>
      )}
    </div>
  );
};
